import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../environments/environment';
import { MapDirectionsService } from '@angular/google-maps';
import * as turf from '@turf/turf';

@Injectable({
  providedIn: 'root'
})


export class MapTrainService {

  constructor(private http: HttpClient,private mapDirectionsService : MapDirectionsService) {
  }


  getDetail(start:google.maps.LatLngLiteral,end:google.maps.LatLngLiteral,option:any) {


    const transit: string[] = [];

    let depart: string = "";
    let arrival: string= "";

    const first_mile_mode: string[] = [];
    const first_mile_time: string[] = [];

    const last_mile_mode: string[] = [];
    const last_mile_time: string[] = [];

    //將trafficWay轉為陣列
    for (const key in option.trafficWay) {
      if (option.trafficWay[key]) {
        transit.push(key);
      }
    }
    const now = new Date();
    //ISO時差8個小時，出發時間加10分鐘，否則api邏輯無法給出對應時間。
    now.setTime(now.getTime() + 3600000 * 8 + 60000 * 10);

    //出發或抵達時間
    switch(option.timeWay){
      case "now":
      default:
        depart = now.toISOString().substring(0, 16);
        break;
      case "departure":
        depart = option.goTime;
        break;
      case "arrival":
        arrival = option.goTime;
        break;
    }

    //第一哩路
    for (const key in option.firstMode) {
      if (key.length == 1) {
        if (option.firstMode[key]) {
          first_mile_mode.push(key);
          first_mile_time.push(option.firstMode["time" + key]);
        }
      }
    }

    //最後一哩路
    for (const key in option.lastMode) {
      if (key.length == 1) {
        if (option.lastMode[key]) {
          last_mile_mode.push(key);
          last_mile_time.push(option.lastMode["time" + key]);
        }
      }
    }



    const params: any = {
      origin: start.lat + "," +start.lng ,
      destination : end.lat + "," +end.lng ,
      gc: option.gc,
      top: 5,
      transit: transit.join(','),
      transfer_time: option.transferTime,
      depart:depart,
      arrival:arrival,
      first_mile_mode: first_mile_mode.join(','),
      first_mile_time: first_mile_time.join(','),
      last_mile_mode: last_mile_mode.join(','),
      last_mile_time:last_mile_time.join(',')
    };


    return this.http.get(environment.url +'/mapTrain/getDetail', {params} );
  }


  getAttraction(lat:number,lng:number,meter:number) {
    const params: any = {
      lat: lat,
      lng: lng,
      meter: meter,
    };
    return this.http.get(environment.url +'/mapTrain/getAttraction', {params} );
  }




  getPolylinePoint(section:any){
    let path = [];
    path.push(section.departure.place.location);
    path.push(section.arrival.place.location);
    return path;
  }


  getPolylineStop(section:any){
    let path = [];
    path.push(section.departure.place.location);
    if(section.intermediateStops != null){
      for (let stop of section.intermediateStops) {
        path.push(stop.departure.place.location);
      }
    }
    path.push(section.arrival.place.location);
    return path;
  }


  getPolylineGoogle(section:any,type:string): Promise<any>{
    let path = [];
    let travelMode =  google.maps.TravelMode.WALKING;
    switch(type){
      case "pedestrian":
      default:
        travelMode = google.maps.TravelMode.WALKING;
        break;
      case "drive":
        travelMode = google.maps.TravelMode.DRIVING;
        break;
      case "cycle":
        travelMode = google.maps.TravelMode.BICYCLING;
        break;
    }

    const request: google.maps.DirectionsRequest = {
      origin: section.departure.place.location,
      destination: section.arrival.place.location,
      travelMode: travelMode
    };


    return new Promise((resolve) => {
      this.mapDirectionsService.route(request)
      .subscribe(result => {
          if(result.status == 'OK' ){
            resolve({
                data: result.result.routes[0].legs[0].steps,
                polyline: result.result.routes[0].overview_path
              });
          }else{
            path.push(section.departure.place.location);
            path.push(section.arrival.place.location);
            resolve({
              data: [],
              polyline: path
            });
          }
      });
    });
  }



  getPolylineMrt(section:any){
    let path:number[][] = [];
    let routeLines = [[120.7087513548912,24.18879640453048],[120.71026997527918,24.184159016225692],[120.71029729038776,24.184063681793532],[120.71031692888323,24.18396676995053],[120.71032878374649,24.183868799605477],[120.71033279202481,24.18377029596246],[120.71032893213453,24.18367178782279],[120.71031722476016,24.183573802189244],[120.7102977328542,24.183476865165233],[120.71027056163712,24.183381496558866],[120.71023585590012,24.183288207185058],[120.7101938009032,24.183197497966205],[120.71014462417509,24.183109854536212],[120.71008858831772,24.183025748139812],[120.71002599370468,24.182945627538743],[120.70995717578307,24.182869924407555],[120.70988250417429,24.18279904254183],[120.70980237907656,24.182733364153478],[120.70971723036598,24.1826732399781],[120.70962751309935,24.18261899287228],[120.70953371021267,24.182570913317022],[120.70943632262822,24.182529259417834],[120.70933587465095,24.182494254206517],[120.70923290317603,24.18246608564141],[120.70912796128641,24.182444905707882],[120.70902161195784,24.182430825921926],[120.70891442356185,24.18242392272589],[120.70880697256382,24.18242423299199],[120.70584000031579,24.182260017685735],[120.70305200574558,24.182226098855438],[120.70294712231191,24.18223065302226],[120.70284216063726,24.182228022505285],[120.70273770528092,24.18221822079431],[120.70263433630566,24.182201302747956],[120.70253263017685,24.18217736369445],[120.702433152568,24.182146534934702],[120.7023364565623,24.182108990037932],[120.70224308085358,24.18206493584819],[120.70215354435061,24.182014619679023],[120.70206834617727,24.18195831942097],[120.70198796027626,24.181896349836734],[120.70191283361044,24.181829055366677],[120.70184338526406,24.181756811028038],[120.70178000014698,24.181680017918552],[120.69854000002101,24.17445001725457],[120.69847690988149,24.174318099300876],[120.69842035511533,24.174183709110935],[120.69837045083568,24.17404712007857],[120.69832729956534,24.173908609194996],[120.69829098673972,24.17376845614939],[120.69826158700266,24.173626946026786],[120.69823915881022,24.173484365710976],[120.69831413888642,24.17171856126265],[120.69829768578961,24.171628037304117],[120.69827363701881,24.171538954958862],[120.69824213646552,24.171451849323432],[120.69820337388671,24.17136724560197],[120.69815758130744,24.171285651911376],[120.69810503571887,24.17120755928147],[120.69804605188381,24.17113343625914],[120.69798098503452,24.171063729807315],[120.6979102272752,24.170998858110863],[120.69783420218675,24.170939212374776],[120.69775336842326,24.17088514963001],[120.69766821161875,24.170836997229685],[120.6975792443867,24.17079504205759],[120.69748700002515,24.170759538621837],[120.6973920352143,24.170730700061824],[120.69729492012448,24.17070869904728],[120.6971962384157,24.170693667778608],[120.69709658453985,24.170685697087322],[120.69699655654586,24.170684835536804],[120.69689675697987,24.170691086724332],[120.69679778568934,24.17070441467706],[120.69670023712627,24.170724738455988],[120.69660469854807,24.170751935753287],[120.69651174372211,24.17078584289237],[120.69642193292589,24.17082625662647],[120.69597121609877,24.170923307864427],[120.68246999999053,24.17248001723908],[120.67799000023842,24.17316001712112],[120.67368000023191,24.174000017187097],[120.67302999993456,24.17402001721007],[120.67114999957289,24.173770017372476],[120.66668000028187,24.173050017444382],[120.66408999955388,24.172500017262053],[120.66108000014196,24.171630017611278],[120.65950319991282,24.17113661716121],[120.65798000017696,24.17056001773068],[120.65623999997604,24.16955001791905],[120.6547299995899,24.16840001704719],[120.65326000014898,24.167240017512825],[120.65164999964782,24.16561001788807],[120.64692860477135,24.158650123204666],[120.64687955035106,24.158587926991288],[120.64683621471954,24.158522253099534],[120.64679888745877,24.158453542197265],[120.64676781947935,24.158382257435278],[120.6467432203234,24.1583088763536],[120.64672525546621,24.158233893579393],[120.64671404451758,24.158157812732895],[120.64670966391986,24.158081144629193],[120.64671214245152,24.158004404579685],[120.64671000026635,24.14661001763824],[120.64673000028938,24.142630017561316],[120.6464850825206,24.13683960936055],[120.64646999999059,24.134420017569823],[120.64621840565496,24.126277660085975],[120.64621684083465,24.12617633257173],[120.64622252544928,24.12607512916395],[120.64623543521725,24.125974486033726],[120.64625551348126,24.125874837553738],[120.64628267570504,24.125776613599896],[120.64631680227865,24.125680237752817],[120.64635774751207,24.125586125499353],[120.64753620113481,24.12396149392788],[120.6476352992297,24.123843959731005],[120.64772923341741,24.12372290738631],[120.64781785710852,24.12359852665071],[120.64790102910922,24.123471015375117],[120.64797861991747,24.123340574108283],[120.64805050632583,24.12320740789562],[120.64811657502003,24.123071726279193],[120.6481767216784,24.122933745096304],[120.64826914950174,24.122558480489545],[120.64835430360824,24.12218176887359],[120.64843215611916,24.12180372895898],[120.64850268365194,24.12142447945621],[120.6485658628244,24.12104414087446],[120.64862167385127,24.12066283282354],[120.64867009964541,24.12028067581258],[120.64866355527886,24.12019717825723],[120.64864961039132,24.12011444962218],[120.64862835761267,24.12003304119196],[120.64859993903599,24.119953495257676],[120.64856454351889,24.11987634331865],[120.64852240848245,24.119802097988497],[120.648473814515,24.119731256592274],[120.64841908447318,24.119664289475452],[120.64835858348192,24.119601643601015],[120.64829271623591,24.119543738053096],[120.64269999970531,24.116120017225057],[120.6391800001569,24.11377001767221],[120.63358184002993,24.11028417617382],[120.63208451019204,24.10963841168342],[120.63162330097464,24.109493650511638],[120.63115980118391,24.109355191788723],[120.63069411424203,24.10922306429302],[120.63022634087304,24.109097297702192],[120.6297565862975,24.108977919895153],[120.62928495213885,24.10886495695223],[120.62881154361787,24.10875843405455],[120.6283364650559,24.108658374584365],[120.62809764558995,24.108627258041565],[120.62785792770126,24.108602635503303],[120.62761752273059,24.108584529452514],[120.62737663932046,24.108572955177806],[120.62713548791248,24.108567923470957],[120.62689427984719,24.108569437929248],[120.62665322646524,24.108577496754094],[120.62641253820811,24.10859209454958],[120.62617242461772,24.10861321692647],[120.62593309703482,24.108640846797698],[120.62569476320277,24.10867495898225],[120.61291999965829,24.110090017040704],[120.61287999961235,24.110130017086647]];
    let route = turf.lineString(routeLines);
    let start = [section.departure.place.location.lng,section.departure.place.location.lat];
    let end = [section.arrival.place.location.lng,section.arrival.place.location.lat];

    let startIndex = turf.nearestPointOnLine(route, turf.point(start)).properties.index;
    let endIndex = turf.nearestPointOnLine(route, turf.point(end)).properties.index;;
    if(startIndex > endIndex){
      path.push(end);
      path.push(...routeLines.slice(endIndex + 1 , startIndex- 1));
      path.push(start);
    }else{
      path.push(start);
      path.push(...routeLines.slice(startIndex + 1 , endIndex - 1));
      path.push(end);
    }

    return path.map(coord => ({lat: coord[1], lng: coord[0]}));
  }


  getPolylineTra(section:any):Promise<any>{
    const params: any = {
      origin: section.departure.place.location.lat + "," + section.departure.place.location.lng,
      destination : section.arrival.place.location.lat + "," + section.arrival.place.location.lng
    };
    return new Promise((resolve) => {
      this.http.get(environment.url +'/mapTrain/getTra', {params})
      .subscribe((polyArray:any) => {
        if(polyArray.length == 0){
          resolve(this.getPolylineStop(section));
        }else{
          resolve(polyArray);
        }
      });
    });
  }




}
